import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {TenderProcurementsItem} from "../types/tenderProcurements";

const COLLECTION_ID = "6868de83003da2e6bf66"
const databases = new Databases(client);

export const tenderProcurements = {

  async list(queries: string[] = [], limit: number = 100): Promise<TenderProcurementsItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as TenderProcurementsItem);

    } catch (error) {
      throw error;
    }
  },
  async create(data: TenderProcurementsItem): Promise<TenderProcurementsItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as TenderProcurementsItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async update(data: TenderProcurementsItem): Promise<TenderProcurementsItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        COLLECTION_ID,
        id,
        correctData
      ) as unknown as TenderProcurementsItem;
      return updatedItem;
    } catch (error) {
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },
}